
import { useLanguage } from "@/contexts/LanguageContext";
import { Card, CardContent } from "@/components/ui/card";
import { Info, Lightbulb, Target, Palette } from "lucide-react";

const DesignTipsCard = () => {
  const { t } = useLanguage();

  return (
    <Card className="overflow-hidden border-none shadow-lg bg-gradient-to-b from-background to-accent/30 dark:from-card dark:to-accent/10">
      <div className="h-2 bg-gradient-to-r from-primary to-secondary"></div>
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-4">
          <Lightbulb className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-foreground">{t("takeYourDesignToNextLevel")}</h3>
        </div>
        <p className="text-sm text-muted-foreground mb-6 border-l-2 border-primary/20 pl-3 italic">
          {t("designTipsDescription")}
        </p>
        
        <div className="space-y-4">
          {/* Cultural Relevance Note */}
          <div className="bg-card dark:bg-muted/20 p-4 rounded-xl border border-border shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1">
            <div className="flex items-start gap-3">
              <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Target className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-sm mb-1 text-foreground">{t("cultureRelevance")}</h4>
                <p className="text-sm text-muted-foreground">
                  {t("cultureRelevanceNote")}
                </p>
              </div>
            </div>
          </div>

          {/* Visual Clarity Note */}
          <div className="bg-card dark:bg-muted/20 p-4 rounded-xl border border-border shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1">
            <div className="flex items-start gap-3">
              <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Palette className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-sm mb-1 text-foreground">{t("visualClarity")}</h4>
                <p className="text-sm text-muted-foreground">
                  {t("visualClarityNote")}
                </p>
              </div>
            </div>
          </div>

          {/* Call to Action Note */}
          <div className="bg-card dark:bg-muted/20 p-4 rounded-xl border border-border shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1">
            <div className="flex items-start gap-3">
              <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Info className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-sm mb-1 text-foreground">{t("callToAction")}</h4>
                <p className="text-sm text-muted-foreground">
                  {t("callToActionNote")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DesignTipsCard;
